export const apiPaths = {
  ssoApps: {
    load: '/v1/mgmt/sso/idp/apps/load',
  },
};
